import ChatNotesStore from './ChatNotesStore';
export default ChatNotesStore;
